import { t } from '@lingui/macro'
import { TwoFA } from './ProfileRightBar.components/TwoFA'
import { BNBBurn } from './ProfileRightBar.components/BNBBurn'
import { BNBConvert } from './ProfileRightBar.components/BNBConvert'
import { DefaultPage } from './ProfileRightBar.components/DefaultPage'
import { MultiAssetMode } from './ProfileRightBar.components/MultiAssetMode'
import { ExchangeTypeSettings } from './ProfileRightBar.components/ExchangeType'
import style from './style.module.scss'
import { SetPositionMode } from './ProfileRightBar.components/SetPositionMode'
import { Address } from './ProfileRightBar.components/Address'
import { WhitelistManage } from './ProfileRightBar.components/WhitelistManage'
import { AdditionalInfo } from './ProfileRightBar.components/AdditionalInfo'
import { FC } from 'react'
import { useExchangesDisabled } from '@/utils/hooks/useExchangesDisabled'
import { ApiKeyRepair } from './ProfileRightBar.components/ApiKeyRepair'
import { Nickname } from './ProfileRightBar.components/Nickname'
import { useTeamData } from '@/utils/hooks/useTeamData'
import { E_TEAM_USER_MODE } from '@/redux/team/team.types'
import { PinCode } from './ProfileRightBar.components/PinCode'
import { useActiveExchage } from '@/utils/hooks/useActiveExchange'
import { Section } from './ProfileRightBar.components/Section/Sections'

const ProfileRightBar: FC = () => {
  const { activeExchange } = useActiveExchage()

  const { isAccountSettingsEnabled } = useExchangesDisabled()
  const { userData } = useTeamData()

  const profile = activeExchange.pages.profile

  return (
    <div className={style.root}>
      <h2 className={style.heading}>{t({ id: 'profile.title', message: `Settings` })}</h2>

      {userData.userMode !== E_TEAM_USER_MODE.noTeam && (
        <Section>
          <Nickname />
        </Section>
      )}

      <Section>
        <ExchangeTypeSettings />
      </Section>

      <Section title={t({ id: 'profile.address.heading', message: `Withdrawal` })}>
        {profile.address && <Address />}
        {profile.whitelist && <WhitelistManage />}
      </Section>

      <Section title={t({ id: 'profile.apiRepair.heading', comment: 'repair api heading' })}>
        {profile.apiKeyRepair && <ApiKeyRepair />}
      </Section>

      <Section>
        <TwoFA />
      </Section>

      <Section>{profile.assetMode && <MultiAssetMode disabled={!isAccountSettingsEnabled} />}</Section>

      <Section title={t({ id: 'profile.settings.other', message: `Other settings` })}>
        {profile.pinCode && <PinCode />}
        {profile.ordersDefaultPage && <DefaultPage />}
        {profile.additionalInfo && <AdditionalInfo />}
        {profile.positionMode && <SetPositionMode disabled={!isAccountSettingsEnabled} />}
        {profile.bnbBurn && <BNBBurn disabled={!isAccountSettingsEnabled} />}
        {profile.convertSmallBalance && <BNBConvert disabled={!isAccountSettingsEnabled} />}
      </Section>
    </div>
  )
}

export { ProfileRightBar }
